import Plyr, { APITypes } from 'plyr-react'
import PlyrJS from 'plyr/src/js/plyr'
import * as React from 'react'
import { Updater } from 'widgets-for-react'
import { parseMediaVideoFile } from '../../../../../../Shared/Frontend/utils/plyr'
import { cookiePlaceholderClickable, cookiePlaceholderText } from '../../../../cookiebar/cookiebar.layout'
import { cookiebarWidget, isCookieAccepted } from '../../../../cookiebar/cookiebar.widget'
import { dataLayerServices } from '../../../../seo/datalayer'
import { State } from '../../../cmsPage.widget'
import { MediaBlockVideo } from './mediaBlock.state'

export type PurePlyrProps = {
  source?: string
  videoRef: React.Ref<APITypes>
}

export class PurePlyr extends React.PureComponent<PurePlyrProps> {
  render() {
    let videoUrl = parseMediaVideoFile(this.props.source || '')
    return <Plyr ref={this.props.videoRef} source={videoUrl.v as any} />
  }
}

type VideoLayoutProps = {mediaBlock: MediaBlockVideo, rootState: State, setState: (_: Updater<State>) => void}
export function VideoLayout(props: VideoLayoutProps): JSX.Element {
  const { mediaBlock, rootState, setState } = props

  let plyrRef = React.useRef<APITypes>(null)
  let percentageArray: Array<number> = []

  const onPlay = () => dataLayerServices.videoDataLayer(mediaBlock.label ? mediaBlock.label : "NoLabel", "video_start")

  const onTimeupdate = ((e: PlyrJS.PlyrEvent) => {

    let percentage: number = Math.round((e.detail.plyr.currentTime/e.detail.plyr.duration)*100)

    if (percentage == 25 || percentage == 50 || percentage == 75 || percentage == 90){
      if (!percentageArray.includes(percentage)){
        percentageArray.push(percentage)
        dataLayerServices.videoDataLayer(mediaBlock.label ? mediaBlock.label : "NoLabel", "video_progress", percentage)
      }
    }})

  const onPause = () => dataLayerServices.videoDataLayer(mediaBlock.label ? mediaBlock.label : "NoLabel", "video_interactions" )

  const onEnded = () => dataLayerServices.videoDataLayer(mediaBlock.label ? mediaBlock.label : "NoLabel", "video_complete")

  const plyr = <PurePlyr videoRef={plyrRef} source={mediaBlock.url} />

  const current = plyrRef.current
  if (plyrRef != undefined && current != undefined) {
    let ply = plyrRef.current!.plyr as PlyrJS
    let on = ply.on
    if (on != undefined) {
      ply.on('play', onPlay)
      ply.on('timeupdate', onTimeupdate)
      ply.on('pause', onPause)
      ply.on('ended', onEnded)
    }
}

  return (
    <>
      {!isCookieAccepted('video-cookies')
        ? cookiebarWidget(
            rootState.cookiebarState,
            'video-cookies',
            cookiePlaceholderText('media'),
            cookiePlaceholderClickable('media')
          ).run((aCs) => {
            setState((s1) => {
              return {
                ...s1,
                cookiestate: aCs(s1.cookiebarState)
              }
            })
          })
        : mediaBlock.url == undefined
        ? 'Unable to load mediaBlock.'
        : plyr
      }
    </>
  )
}
